import * as React from 'react';
import { ButtonProps, Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

const GoToDashboardButton: React.FC<ButtonProps> = (buttonProps) => {
  const navigate = useNavigate()

  const { customer_id } = useParams<{ customer_id?: string }>()

  return (
    <Button {...buttonProps} onClick={() => {
      if (customer_id) {
        navigate(`/${customer_id}`)
      } else {
        navigate(`/`)
      }
    }}>
      {buttonProps.children ?? <>Go to Dashboard</>}
    </Button>
  )
}

export default GoToDashboardButton;
